import { __assign } from "tslib";
import { logNotification } from '@microsoft/oteljs';
import { hookUp1DSNotifications, getAppInsights } from './ApplicationInsights';
import { CUSTOMER_CONTENT_TENANT_TOKEN, tryCatch, voidValue } from './InternalUtils';
import { getCorrespondingCCCOEndpoint } from './OneDSHelper';
/**
 * The CustomerContentHandler is used to send CCCO data to WW and EUDB endpoints.
 * The handler should be added to OneDSSinkProperties.nonStandardEventHandlers when the sink is intialized.
 */
var CustomerContentHandler = /** @class */ (function () {
    function CustomerContentHandler() {
        var _this = this;
        this.eventsProcessed = 0;
        var _customerContentApplicationInsights;
        var _oneDSSink;
        var _specialEventType = 2 /* EventType.CustomerContent */;
        this.initialize = function (oneDSSink, oneDSSinkProperties) {
            var oneDSCCCOEndpoint = getCorrespondingCCCOEndpoint(oneDSSinkProperties.endpointUrl);
            if (oneDSCCCOEndpoint) {
                var cccoProperties = __assign(__assign({}, oneDSSinkProperties), { endpointUrl: oneDSCCCOEndpoint, extensionConfig: __assign(__assign({}, oneDSSinkProperties.extensionConfig), { PrivacyGuardPlugin: {} }), nonStandardEventHandlers: [], plugins: [] });
                _customerContentApplicationInsights = getAppInsights(cccoProperties, CUSTOMER_CONTENT_TENANT_TOKEN);
            }
            else {
                logNotification(0 /* LogLevel.Error */, 1 /* Category.Sink */, function () { return 'Missing 1DS CCCO Endpoint'; });
                return;
            }
            if (!oneDSSinkProperties.disableStatsTracking) {
                hookUp1DSNotifications(oneDSSink, _customerContentApplicationInsights);
            }
            _oneDSSink = oneDSSink;
        };
        this.shutdown = function () {
            _customerContentApplicationInsights === null || _customerContentApplicationInsights === void 0 ? void 0 : _customerContentApplicationInsights.shutdown();
        };
        this.flush = function (async) {
            _customerContentApplicationInsights === null || _customerContentApplicationInsights === void 0 ? void 0 : _customerContentApplicationInsights.flush(async);
        };
        this.canHandle = function (telemetryEventType) {
            return _oneDSSink && telemetryEventType === _specialEventType;
        };
        this.processEvent = function (telemetryEvent) {
            _this.eventsProcessed++;
            return tryCatch(function () {
                var event = _oneDSSink.getOneDSCustomerContent(telemetryEvent);
                if (event && _customerContentApplicationInsights) {
                    _customerContentApplicationInsights === null || _customerContentApplicationInsights === void 0 ? void 0 : _customerContentApplicationInsights.track(event);
                }
            }, voidValue);
        };
    }
    return CustomerContentHandler;
}());
export { CustomerContentHandler };
//# sourceMappingURL=CustomerContentHandler.js.map